// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-time-tooltip-container{position:relative;display:inline-block;color:var(--coral);font-family:var(--font-bold);line-height:1;cursor:pointer;border-bottom:1px dotted var(--coral)}.delivery-time-tooltip-container .delivery-time-tooltip{display:none;width:auto;max-width:100%;text-align:left;padding:var(--space-3);font-size:var(--font-size-12);line-height:var(--line-height-12);background:var(--white);color:var(--font-color);font-family:var(--font-light);z-index:30;position:absolute;bottom:200%;right:0;border-radius:var(--space-1);box-shadow:0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);white-space:normal}@media (min-width: 375px){.delivery-time-tooltip-container .delivery-time-tooltip{max-width:none;width:160px}}@media (min-width: 970px){.delivery-time-tooltip-container .delivery-time-tooltip{width:230px}}.delivery-time-tooltip-container:hover .delivery-time-tooltip{display:block}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
